<template>
  <vue-editor v-model="value" />
</template>

<script>
import { VueEditor, Quill } from 'vue2-editor'
import { abstractField } from 'vue-form-generator'

export default {
  mixins: [abstractField],
  components: {
    VueEditor
  }
}
</script>

<style scoped>

</style>
